import { render, staticRenderFns } from "./ChooseFreePlanSection.vue?vue&type=template&id=5fe74256&scoped=true"
import script from "./ChooseFreePlanSection.vue?vue&type=script&lang=ts"
export * from "./ChooseFreePlanSection.vue?vue&type=script&lang=ts"
import style0 from "./ChooseFreePlanSection.vue?vue&type=style&index=0&id=5fe74256&prod&lang=scss&scoped=true"
import style1 from "./ChooseFreePlanSection.vue?vue&type=style&index=1&id=5fe74256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe74256",
  null
  
)

export default component.exports